import { defineAsyncComponent } from 'vue';

export default {
	description: "Файлы",
	access: {
		read: true,
		create: true,
		update: true,
		delete: true
	},
	forms: {
		edit: {
			panel: {
				// height: '280px',
				width: '70%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		}
	}
}